import styles from "./styles";
import React, { useState } from "react";
import HomePage from "../../../../Diathrive/src/containers/HomePage";
import { useNavigate } from "react-router-dom";
import NextAppointments from "./NextAppointments";

const HomeLayout = ({ ViewBSHistory = false }) => {
  const navigate = useNavigate();
  const [rightPanelComponent, setRightPanelComponent] = useState(null);
  return (
    <div style={styles.container}>
      <div style={styles.mainPannel}>
        <HomePage
          navigation={navigate}
          ViewBSHistory={ViewBSHistory}
          setRightPanelComponent={setRightPanelComponent}
        />
      </div>
      <div style={styles.homeRightPannel}>
        {ViewBSHistory ? rightPanelComponent : <NextAppointments />}
      </div>
    </div>
  );
};

export default HomeLayout;
